import { FormState } from '../../interfaces/form/FormState';
import { SET_HAS_ERROR, SET_IS_FETCHED } from './formActionTypes';
import { FormAction } from '../../interfaces/form/FormAction';

const initialState: FormState = {
  isFetched: false,
  hasError: false,
};

const navReducer = (state = initialState, action: FormAction): FormState => {
  switch (action.type) {
    case SET_HAS_ERROR:
      return { ...state, hasError: action.hasError };
    case SET_IS_FETCHED:
      return { ...state, isFetched: action.isFetched };
    default:
      return state;
  }
};

export default navReducer;
